module.exports = __webpack_public_path__ + "img/Newsfeed.23c79cbe.svg";